import { FC } from 'react';
import { Navigate, Outlet } from 'react-router';

import { useAppSelector } from 'hooks/redux';
import { authSelector } from 'store/authState';
import * as routes from 'router/routes';

// Auth route
export const AuthRoute: FC = () => {
  const { authenticated } = useAppSelector(authSelector);

  if (!authenticated) {
    return <Navigate to={routes.LOGIN} />;
  }

  return <Outlet />;
};
